import angular from 'angular';
import { authenticatedUser } from 'header-scripts';
import accountSettingsModule from '../accountSettingsModule';

function changeDisplayNameController(
  $scope,
  usersService,
  $uibModalInstance,
  injectedData,
  eventStreamService,
  displayNameLayout,
  displayNameConstants,
  $timeout
) {
  'ngInject';

  const rawPageData = injectedData.pageData;
  $scope.modalData = {
    originalDisplayName: angular.copy(rawPageData.DisplayName),
    newDisplayName: '',
    currentDisplayName: angular.copy(rawPageData.DisplayName)
  };
  $scope.modalLayout = angular.copy(displayNameLayout.changeDisplayNameLayout);

  const {
    eventstreamParams: { changeDisplayNameEvent, successCtx, cancelCtx }
  } = displayNameConstants;

  $scope.handleResponseFailure = failureResponse => {
    if (failureResponse?.errors && failureResponse?.errors.length > 0) {
      const error = failureResponse?.errors[0];
      const { code } = error;
      const { errorMessages, errorCodeMapMsg } = displayNameLayout.changeDisplayNameResponse;
      const nameOfErrorMsg = errorCodeMapMsg[code];
      $scope.modalLayout.displayErrorMsg = errorMessages[nameOfErrorMsg];
    }
  };

  const currentUserId = authenticatedUser?.id;
  $scope.saveDisplayName = () => {
    const { originalDisplayName, currentDisplayName } = $scope.modalData;
    usersService.updateDisplayName(authenticatedUser?.id, currentDisplayName).then(
      () => {
        $scope.modalLayout.isRequestFailed = false;
        rawPageData.DisplayName = currentDisplayName;
        eventStreamService.sendEventWithTarget(changeDisplayNameEvent, successCtx, {
          currentDisplayName,
          originalDisplayName
        });
        $uibModalInstance.dismiss();
      },
      failureResponse => {
        $scope.modalLayout.isRequestFailed = true;
        $scope.modalData.currentDisplayName = originalDisplayName;
        $scope.handleResponseFailure(failureResponse);
      }
    );
  };

  $scope.close = () => {
    const { originalDisplayName } = $scope.modalData;
    eventStreamService.sendEventWithTarget(changeDisplayNameEvent, cancelCtx, {
      newDisplayName: null,
      originalDisplayName
    });
    $scope.modalData.currentDisplayName = originalDisplayName;
    $timeout.cancel($scope.timeoutValidateDisplayName);
    $uibModalInstance.dismiss();
  };

  $scope.validateInputChange = () => {
    $scope.modalLayout.isRequestFailed = false;

    const { currentDisplayName } = $scope.modalData;
    if (currentDisplayName.length < $scope.modalLayout.minCharactersForDisplayName) {
      $scope.modalLayout.isValidated = false;
      const { errorMessages } = displayNameLayout.changeDisplayNameResponse;
      $scope.modalLayout.displayErrorMsg = errorMessages.nameTooShort;
    } else if (!$scope.modalLayout.isValidating) {
      console.log(`timeout${$scope.modalLayout.isValidating}`);
      $scope.timeoutValidateDisplayName = $timeout(() => {
        $scope.modalLayout.isValidating = true;
        usersService
          .validateDisplayName(authenticatedUser?.id, currentDisplayName)
          .then(
            () => {
              $scope.modalLayout.isValidated = true;
            },
            failureResponse => {
              $scope.modalLayout.isValidated = false;
              $scope.handleResponseFailure(failureResponse);
            }
          )
          .finally(() => {
            $scope.modalLayout.isValidating = false;
            $timeout.cancel($scope.timeoutValidateDisplayName);
          });
      }, 0);
    }
  };

  $scope.isInputFormInvalidated = () => {
    return $scope.modalLayout.isRequestFailed || !$scope.modalLayout.isValidated;
  };
}
accountSettingsModule.controller('changeDisplayNameController', changeDisplayNameController);

export default changeDisplayNameController;
